// @flow

import { cloneDeep, get, set } from 'lodash';

import type { DocumentNode } from 'graphql';

import type { CacheType } from 'app/graphql/types';

type ResultType = {
  data: any,
};

export const buildCreationUpdater = ({
  queryKey,
  mutationKey,
}: {
  queryKey: string | Array<string>,
  mutationKey: string,
}) => (query: DocumentNode, variables: {}) => (
  cache: CacheType,
  mutationResult: ResultType
) => {
  const fullQuery = {
    query,
    variables,
  };
  const cachedQueryResult = cache.readQuery(fullQuery);
  const cachedQueryItems = get(cachedQueryResult, queryKey);
  const newItem = mutationResult.data[mutationKey];
  const data = set(cachedQueryResult, queryKey, [...cachedQueryItems, newItem]);
  cache.writeQuery({
    ...fullQuery,
    data,
  });
};

export const buildDeletionUpdater = ({
  queryKey,
  mutationKey,
}: {
  queryKey: string | Array<string>,
  mutationKey: string,
}) => (query: DocumentNode, variables: {}) => (
  cache: CacheType,
  mutationResult: ResultType
) => {
  const fullQuery = {
    query,
    variables,
  };
  const cachedQueryResult = cache.readQuery(fullQuery);
  const cachedQueryItems = get(cachedQueryResult, queryKey);
  const newItem = mutationResult.data[mutationKey];
  const id = newItem.id || newItem;
  const data = set(
    // if we don't clone the <Query> tags don't get notified
    cloneDeep(cachedQueryResult),
    queryKey,
    cachedQueryItems.filter(item => item.id !== id)
  );
  cache.writeQuery({
    ...fullQuery,
    data,
  });
};
